import { RootState } from '@reducers';

export const selectCorporateHealthPolicyDetails = (state: RootState) =>
  state.userDashboardRouteReducer.policyDetailsReducer.corporateHealthPolicyDetailsReducer;
